/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_1_WInputs */

const en_cp_cmp_1_w = /** @type {(inputs: Cp_Cmp_1_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD, evidence log, proposal PDF and readiness score as attachments; monitoring read from phase approvals.`)
};

const id_cp_cmp_1_w = /** @type {(inputs: Cp_Cmp_1_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD, log bukti, proposal PDF, dan skor kesiapan sebagai lampiran; monev dibaca dari persetujuan fase.`)
};

/**
* | output |
* | --- |
* | "PRD, evidence log, proposal PDF and readiness score as attachments; monitoring read from phase approvals." |
*
* @param {Cp_Cmp_1_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_1_w = /** @type {((inputs?: Cp_Cmp_1_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_1_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_1_w(inputs)
	return en_cp_cmp_1_w(inputs)
});